import MarketingAPI from '../../api/marketing';

export const state = {
  whatsappTemplates: [],
  uiFlags: {
    isCreating: false,
    isFetchingTemplates: false,
    isSyncingTemplates: false,
    isCreatingTemplate: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getWhatsAppTemplates(_state) {
    return _state.whatsappTemplates;
  },
  // The whole entry, not just the templates: the composer needs the sync error
  // and the unusable-by-status counts to explain an empty picker.
  getTemplateEntryForInbox: _state => inboxId => {
    return _state.whatsappTemplates.find(
      entry => entry.inbox_id === Number(inboxId)
    );
  },
  getTemplatesForInbox: (_state, _getters) => inboxId => {
    return _getters.getTemplateEntryForInbox(inboxId)?.templates ?? [];
  },
};

export const actions = {
  fetchWhatsAppTemplates: async ({ commit }) => {
    commit('SET_MARKETING_UI_FLAG', { isFetchingTemplates: true });
    try {
      const response = await MarketingAPI.whatsappTemplates();
      commit('SET_WHATSAPP_TEMPLATES', response.data.payload);
    } finally {
      commit('SET_MARKETING_UI_FLAG', { isFetchingTemplates: false });
    }
  },
  // Runs the sync server-side in the request, so the picker works even when the
  // sidekiq worker that owns the scheduled sync is down.
  syncWhatsAppTemplates: async ({ commit }) => {
    commit('SET_MARKETING_UI_FLAG', { isSyncingTemplates: true });
    try {
      const response = await MarketingAPI.syncWhatsappTemplates();
      commit('SET_WHATSAPP_TEMPLATES', response.data.payload);
      return response.data.payload;
    } finally {
      commit('SET_MARKETING_UI_FLAG', { isSyncingTemplates: false });
    }
  },
  // Meta assigns the id and the status, so the list is refetched rather than
  // patched: the new template shows up as PENDING until Meta reviews it.
  createWhatsAppTemplate: async (
    { commit, dispatch },
    { inboxId, template }
  ) => {
    commit('SET_MARKETING_UI_FLAG', { isCreatingTemplate: true });
    try {
      const response = await MarketingAPI.createWhatsappTemplate(
        inboxId,
        template
      );
      await dispatch('fetchWhatsAppTemplates');
      return response.data.payload;
    } finally {
      commit('SET_MARKETING_UI_FLAG', { isCreatingTemplate: false });
    }
  },
  createCampaign: async ({ commit, dispatch }, formData) => {
    commit('SET_MARKETING_UI_FLAG', { isCreating: true });
    try {
      const response = await MarketingAPI.create(formData);
      // Both lists are refreshed because a campaign can have created a post, a
      // broadcast, or both.
      await Promise.all([
        dispatch('socialPosts/get', null, { root: true }),
        dispatch('broadcasts/get', null, { root: true }),
      ]);
      return response.data;
    } finally {
      commit('SET_MARKETING_UI_FLAG', { isCreating: false });
    }
  },
};

export const mutations = {
  SET_MARKETING_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  SET_WHATSAPP_TEMPLATES(_state, data) {
    _state.whatsappTemplates = data ?? [];
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
